// extracted by mini-css-extract-plugin
export default {"dropdownOverlay":"styles_dropdownOverlay__rLJJ3"};